import React from 'react';
import { LineChartIcon } from 'lucide-react';
export function AuthShell({
  title,
  subtitle,
  children,
  footer
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return <main className="flex min-h-screen w-full items-center justify-center bg-surface/40 px-5 py-10" data-id="element-26" data-mp="n17df167474y">
      <div className="w-full max-w-[420px]" data-id="element-27" data-mp="rua7rbisrkm7">
        <div className="mb-6 flex items-center gap-2.5" data-id="element-28" data-mp="wrsj18kaebxd">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-ink text-white" data-id="element-29" data-mp="wrabvgw36dao">
            <LineChartIcon className="h-4 w-4" strokeWidth={2.4} data-id="element-30" data-mp="11pbxa8gziopb" />
          </div>
          <div className="leading-tight" data-id="element-31" data-mp="15tjl83fmc0mh">
            <p className="text-[15px] font-semibold tracking-tight" data-id="element-32" data-mp="15qnq0mv5nq1q">DZE Journal</p>
            <p className="text-[11px] text-ink-soft" data-id="element-33" data-mp="1aqs64bs5iirf">Trading diary</p>
          </div>
        </div>

        <section className="rounded-2xl border border-line bg-white p-6 shadow-card" data-id="element-34" data-mp="37loaf75qgjti">
          <h1 className="text-xl font-semibold tracking-tight" data-id="element-35" data-mp="3cjgcuv407oby">{title}</h1>
          <p className="mt-1 text-[13px] leading-relaxed text-ink-soft" data-id="element-36" data-mp="c87ns1kb53ka">{subtitle}</p>
          <div className="mt-5" data-id="element-37" data-mp="7fxt6888zfbo">{children}</div>
        </section>

        {footer && <div className="mt-4 text-center text-[13px] text-ink-soft" data-id="element-38" data-mp="3evqtij1an5h">{footer}</div>}
      </div>
    </main>;
}
export function AuthError({
  message
}: {
  message?: string;
}) {
  if (!message) return null;
  return <p role="alert" className="rounded-lg border border-neg-border bg-neg-soft px-3 py-2 text-[12.5px] font-medium text-neg" data-id="element-39" data-mp="v6jyhrqvalhz">
      {message}
    </p>;
}
export function AuthNotice({
  message
}: {
  message?: string;
}) {
  if (!message) return null;
  return <p role="status" className="rounded-lg border border-pos-border bg-pos-soft px-3 py-2 text-[12.5px] font-medium text-pos" data-id="element-40" data-mp="m7ge8kfys01w">
      {message}
    </p>;
}
export function LinkButton({
  children,
  onClick
}: {
  children: React.ReactNode;
  onClick: () => void;
}) {
  return <button type="button" onClick={onClick} className="font-medium text-ink underline decoration-line underline-offset-2 hover:decoration-ink" data-id="element-41" data-mp="31vq7n4akvdbo">
      {children}
    </button>;
}